import React, { useLayoutEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Lenis from "@studio-freight/lenis";
import Footer from "../components/Footer/Footer";
import Navbar from "../components/Navbar/Navbar";
import Service from "../components/Service/Service";

function Servicepage() {
  const lenis = new Lenis({
    duration: 2,
  });

  lenis.on("scroll", (e) => {
    console.log(e);
  });

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }

  requestAnimationFrame(raf);

  useLayoutEffect(() => {
    AOS.init();
  }, []);
  return (
    <>
      <Navbar />
      <Service />
      <Footer />
    </>
  );
}

export default Servicepage;
